import axios from "axios";

const state = () => ({
  courseIntegration: null,
});

const mutations = {
  SET_GOLFWEATHER_ID(state, golfWeatherId) {
    state.courseIntegration = golfWeatherId;
  },
};

const getters = {
  getCourseIntegration: (state) => {
    return state.courseIntegration;
  },
};

const actions = {
  async fetchGolfWeatherId({ commit }, courseId) {
    if (!courseId) {
      commit("SET_GOLFWEATHER_ID", null);
      return null;
    }
    const url = `${process.env.VUE_APP_API_URL}/utilities/golfweather/${courseId}`;
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_GOLFWEATHER_ID", response.data);
      return response.data;
    } catch (error) {
      console.log("Error fetching course integration:", error);
    }
  },

  async updateCourseIntegration(_, payload) {
    const url = `${process.env.VUE_APP_API_URL}/utilities/golfweather/${payload.id}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
        "Content-Type": "application/json",
      },
    };

    const data = {
      golfWeatherId: payload.golfWeatherId,
    };

    try {
      const response = await axios.patch(url, data, config);
      return response;
    } catch (error) {
      console.log("Error updating course integration:", error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
